import { render, staticRenderFns } from "./AnnmtDialog.vue?vue&type=template&id=2d783eec&scoped=true"
import script from "./AnnmtDialog.vue?vue&type=script&lang=js"
export * from "./AnnmtDialog.vue?vue&type=script&lang=js"
import style0 from "./AnnmtDialog.vue?vue&type=style&index=0&id=2d783eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d783eec",
  null
  
)

export default component.exports